export default function Disclaimer() {
  return (
    <div className="text-xs text-gray-600 max-w-2xl mx-auto">
      Disclaimer: All copyrights, trademarks, and other intellectual property
      rights associated with LinkedIn and the Queens Game belong to LinkedIn
      Corporation. This project is created for entertainment purposes only and
      is not affiliated with or endorsed by LinkedIn.
    </div>
  );
}
